import { createApp } from 'vue'
import store from './store'
import App from './App.vue'
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css"; 
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import registerGlobals from './utils/prototype.js'
import registerDirectives from './utils/directive.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/index.css';

// 👉 Leggi i dataset PRIMA del mount
const rootEl = document.getElementById('app-enrol');
if (rootEl?.dataset) {
    store.dispatch('settings/loadFromDataset', rootEl.dataset);
}

// 👉 Leggi gli URL param
const urlParams = new URLSearchParams(window.location.search);
if ([...urlParams].length > 0) {
    store.dispatch('settings/loadFromUrl', urlParams);
}

const app = createApp(App)

app.component("v-select", VueSelect)
app.component('VueDatePicker', VueDatePicker);
app.use(store)
registerGlobals(app, store);
registerDirectives(app);

app.mount('#app-enrol')
